export default {

  showLanding: false
  

}